var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#step-1_svg__clip0_3334_10999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.043-.5H9.957C5.01-.5 1 2.927 1 7.155v184.689c0 4.229 4.01 7.656 8.957 7.656h216.086c4.947 0 8.957-3.427 8.957-7.656V7.155c0-4.228-4.01-7.655-8.957-7.655z",
    fill: "#fff",
    stroke: "#E6EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.01-.5H8.99C4.025-.5 0 2.911 0 7.119v184.762c0 4.208 4.025 7.619 8.99 7.619h218.02c4.965 0 8.99-3.411 8.99-7.619V7.119c0-4.208-4.025-7.619-8.99-7.619z",
    fill: "url(#step-1_svg__paint0_linear_3334_10999)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.542 18.285H22.476a4.495 4.495 0 00-4.495 4.495v22.711a4.495 4.495 0 004.495 4.496h55.066a4.495 4.495 0 004.496-4.496v-22.71a4.495 4.495 0 00-4.496-4.496z",
    fill: "url(#step-1_svg__paint1_linear_3334_10999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.523 31.201h-58.518a3.167 3.167 0 000 6.335h58.518a3.167 3.167 0 100-6.335z",
    fill: "url(#step-1_svg__paint2_linear_3334_10999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.763 71.121H100.17a3.522 3.522 0 100 7.045h98.593a3.523 3.523 0 100-7.045z",
    fill: "url(#step-1_svg__paint3_linear_3334_10999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.287 87.559H100.17a3.522 3.522 0 100 7.044h76.117a3.522 3.522 0 000-7.044z",
    fill: "url(#step-1_svg__paint4_linear_3334_10999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.449 103.996H100.17a3.522 3.522 0 100 7.045h41.279a3.522 3.522 0 000-7.045z",
    fill: "url(#step-1_svg__paint5_linear_3334_10999)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8 90.932c0 1.783-1.804 3.334-2.174 5.003-.383 1.722.575 3.919-.16 5.473-.744 1.579-3.027 2.179-4.086 3.536-1.065 1.362-1.132 3.771-2.466 4.859-1.326 1.083-3.634.618-5.18 1.38-1.519.75-2.599 2.894-4.282 3.286-1.63.379-3.51-1.065-5.252-1.065-1.743 0-3.621 1.444-5.252 1.065-1.684-.392-2.764-2.536-4.284-3.286-1.545-.762-3.853-.297-5.18-1.38-1.333-1.089-1.4-3.497-2.464-4.86-1.06-1.356-3.343-1.957-4.087-3.536-.734-1.553.223-3.75-.16-5.472-.37-1.669-2.173-3.22-2.173-5.003s1.802-3.334 2.173-5.003c.383-1.722-.574-3.918.16-5.472.745-1.58 3.027-2.18 4.087-3.536 1.064-1.363 1.132-3.771 2.465-4.86 1.327-1.083 3.635-.619 5.18-1.38 1.519-.75 2.599-2.894 4.283-3.285 1.63-.38 3.509 1.064 5.252 1.064 1.743 0 3.62-1.444 5.252-1.064 1.684.391 2.763 2.535 4.283 3.285 1.545.762 3.853.297 5.18 1.38 1.333 1.089 1.4 3.497 2.465 4.86 1.059 1.357 3.342 1.957 4.087 3.536.734 1.554-.224 3.75.159 5.472.37 1.668 2.174 3.22 2.174 5.003z",
    fill: "#e80070"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.961 142.838H203.41a8.99 8.99 0 018.99 8.99v14.895a8.99 8.99 0 01-8.99 8.991H35.961a8.991 8.991 0 01-8.99-8.991v-14.895a8.99 8.99 0 018.99-8.99z",
    fill: "url(#step-1_svg__paint6_linear_3334_10999)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint0_linear_3334_10999",
    x1: 118,
    y1: 199.5,
    x2: 118,
    y2: -0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE7F2",
    stopOpacity: 0.795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint1_linear_3334_10999",
    x1: 82.038,
    y1: 30.254,
    x2: 27.496,
    y2: 57.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint2_linear_3334_10999",
    x1: 217.691,
    y1: 31.201,
    x2: 152.838,
    y2: 31.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint3_linear_3334_10999",
    x1: 202.286,
    y1: 71.121,
    x2: 96.647,
    y2: 71.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint4_linear_3334_10999",
    x1: 179.809,
    y1: 87.559,
    x2: 96.647,
    y2: 87.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint5_linear_3334_10999",
    x1: 144.971,
    y1: 103.996,
    x2: 96.647,
    y2: 103.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-1_svg__paint6_linear_3334_10999",
    x1: 212.399,
    y1: 142.838,
    x2: 26.971,
    y2: 142.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93B9A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "step-1_svg__clip0_3334_10999"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h236v200H0z"
  })))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/step-1-5d17d39fe8d24c1d53780ea869cbc13d.svg";
export { SvgStep1 as ReactComponent };